import * as Scrivito from "scrivito";
import { Helmet } from "react-helmet-async";
import getMetadata from "../utils/getMetadata";
import favicon from "../assets/images/favicon.png";
import faviconLiv from "../assets/images/favicon-liv.png";
import font from "../assets/fonts/rubik-v21/rubik-v21-latin-ext_latin_hebrew_cyrillic-ext_cyrillic-300.woff";

import { isLiv } from "../utils/isLiv";

const CurrentPageMetadata = Scrivito.connect(() => {
  const page = Scrivito.currentPage();
  const htmlAttributes = { lang: "de" };
  let title = "";
  let meta = [];
  const links = [
    {
      rel: "shortcut icon",
      type: "image/png",
      href: isLiv(page) ? faviconLiv : favicon,
    },
  ];

  if (page) {
    title = page.get("title") || "Hochschule Heilbronn";
    meta = getMetadata(page);
    links.push({ rel: "canonical", href: Scrivito.urlFor(page) });
    links.push({
      rel: "preload",
      href: font,
      as: "font",
      type: "font/woff2",
      crossorigin: "anonymous",
    });
    htmlAttributes.lang = page.language();
  }

  return (
    <Helmet
      meta={meta}
      htmlAttributes={htmlAttributes}
      title={title}
      link={links}
    />
  );
});

export default CurrentPageMetadata;
